export interface StandardHeaders {
    'Accept': string;
    'Content-Type': string;
    'Authorization': string;
  }
  
export const defaultStandardHeaders: StandardHeaders = {
    'Accept': '*/*',
    'Content-Type': 'application/json',
    'Authorization': '',
};